import React, { useState, useEffect } from "react";
import Modal from "../../shared/components/Modal.js";
import "../styles/Patients.css";
import "../../shared/styles/Global.css";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CreatePatient from "../components/CreatePatient.js";
import PatientSearch from "../components/PatientSearch.js";
import PatientHistory from "../components/PatientHistory.js";
import AddHistory from "../components/AddHistory.js";
import DeleteHistory from "../components/DeleteHistory.js";
import AddEvolution from "../components/AddEvolution.js";
import PatientEvolutions from "../components/PatientEvolutions.js";
import DeleteEvolution from "../components/DeleteEvolution.js";
import UploadFile from "../components/UploadFile.js";
import FileList from "../components/FileList.js";
import DeleteFile from "../components/DeleteFile.js";
import EditPatientButton from "../components/EditPatientButton";
import EditPatientForm from "../components/EditPatientForm";
import PatientList from "../components/PatientList";
import DeletePatient from "../components/DeletePatient";

import { getFirestore, doc, onSnapshot } from "firebase/firestore";

import AppFooter from "../../shared/components/AppFooter";

function Patients() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const [isListOpen, setIsListOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const [selectedPatientId, setSelectedPatientId] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const openModal = (content) => {
    if (content === "list") {
      setIsListOpen(true);
    } else if (content === "delete") {
      setIsDeleteModalOpen(true);
    } else {
      setModalContent(content);
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  const handleSelectPatient = (patient) => {
    setSelectedPatientId(patient.id);
    closeModal();
    setIsListOpen(false);
  };

  useEffect(() => {
    if (!selectedPatientId) {
      setSelectedPatient(null);
      return;
    }

    const db = getFirestore();
    const patientRef = doc(db, "registeredPatients", selectedPatientId);

    const unsubscribe = onSnapshot(patientRef, (docSnap) => {
      if (docSnap.exists()) {
        setSelectedPatient({ id: docSnap.id, ...docSnap.data() });
      } else {
        setSelectedPatient(null);
      }
    });

    return () => unsubscribe();
  }, [selectedPatientId]);

  return (
    <>
      <section className="patientsSection fadeIn">
        <div className="firstPatientsContainer">
          <img src="/images/patientManager1.svg" alt="" />
        </div>

        <div className="secondPatientsContainer">
          <button className="icon-button" onClick={() => openModal("create")}>
            <span className="material-icons">person_add</span>
          </button>
          <button className="icon-button" onClick={() => openModal("search")}>
            <span className="material-icons">search</span>
          </button>

          <button className="icon-button" onClick={() => openModal("list")}>
            <span className="material-icons">list</span>
          </button>

          <button className="icon-button" onClick={() => openModal("delete")}>
            <span className="material-icons">delete</span>
          </button>
        </div>

        <div className="dataContainer">
          {selectedPatient ? (
            <>
              <div className="dataContainer1">
                <div className="patientDetails">
                  <h2>Información del paciente</h2>
                  <EditPatientForm
                    selectedPatient={selectedPatient}
                    setSelectedPatient={setSelectedPatient}
                    isEditing={isEditing}
                    setIsEditing={setIsEditing}
                  />

                  <EditPatientButton
                    isEditing={isEditing}
                    setIsEditing={setIsEditing}
                  />
                </div>
              </div>

              <div className="dataContainer2">
                <div className="subDataContainer2">
                  <h2>Antecedentes</h2>
                  <PatientHistory selectedPatient={selectedPatient} />
                  <div className="butttonContainer">
                    <button
                      className="smallButton"
                      onClick={() => openModal("addHistory")}
                    >
                      Agregar
                    </button>
                    <button
                      className="smallButton"
                      onClick={() => openModal("deleteHistory")}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>

                <div className="subDataContainer2">
                  <h2>Evoluciones</h2>
                  <PatientEvolutions selectedPatient={selectedPatient} />
                  <div className="butttonContainer">
                    <button
                      className="smallButton"
                      onClick={() => openModal("addEvolution")}
                    >
                      Agregar
                    </button>
                    <button
                      className="smallButton"
                      onClick={() => openModal("deleteEvolution")}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>

                <div className="subDataContainer2">
                  <h2>Archivos</h2>

                  <FileList
                    files={Object.entries(selectedPatient.files || {}).map(
                      ([uniqueFileName, fileData]) => ({
                        path: `patientFiles/${selectedPatient.id}/${uniqueFileName}`,
                        label: `${new Date(fileData.uploadedAt).toLocaleString()} - ${fileData.originalName}`,
                      }),
                    )}
                  />

                  <div className="butttonContainer">
                    <button
                      className="smallButton"
                      onClick={() => openModal("uploadFile")}
                    >
                      Agregar
                    </button>
                    <button
                      className="smallButton"
                      onClick={() => openModal("deleteFile")}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="noPatientSelected">
              <p>No hay una persona seleccionada.</p>
            </div>
          )}
        </div>

        <PatientList
          isOpen={isListOpen}
          onClose={() => setIsListOpen(false)}
          onSelectPatient={handleSelectPatient}
        />

        <DeletePatient
          isOpen={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
          selectedPatient={selectedPatient}
          resetSelectedPatient={() => setSelectedPatientId(null)}
        />
      </section>

      <Modal isOpen={isModalOpen} onClose={closeModal}>
        {modalContent === "create" && <CreatePatient />}
        {modalContent === "search" && (
          <PatientSearch onSelectPatient={handleSelectPatient} />
        )}

        {modalContent === "addHistory" && (
          <AddHistory selectedPatient={selectedPatient} onClose={closeModal} />
        )}
        {modalContent === "deleteHistory" && (
          <DeleteHistory
            selectedPatient={selectedPatient}
            onClose={closeModal}
          />
        )}
        {modalContent === "addEvolution" && (
          <AddEvolution
            selectedPatient={selectedPatient}
            onClose={closeModal}
          />
        )}
        {modalContent === "deleteEvolution" && (
          <DeleteEvolution
            selectedPatient={selectedPatient}
            onClose={closeModal}
          />
        )}
        {modalContent === "uploadFile" && (
          <UploadFile selectedPatient={selectedPatient} onClose={closeModal} />
        )}
        {modalContent === "deleteFile" && (
          <DeleteFile selectedPatient={selectedPatient} onClose={closeModal} />
        )}
      </Modal>

      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <AppFooter />
    </>
  );
}

export default Patients;
